import * as React from 'react';

const VariantStyles = {
    "Input" : {
        // Slate-blue gradient: darker at root, lighter as depth increases
        "bgcolor": ["#dce4ed","#e2e9f0","#e8eef4","#eef2f7","#f3f6f9","#f7f9fb","#fafbfd","#fcfdfe","#fefeff"],
        "typecolor": "#0070cc"
    },
    "Output": {
        // Warm-orange gradient: more saturated at root, lighter as depth increases
        "bgcolor": ["#f5c88a","#f7d09a","#f8d8aa","#f9dfba","#fae6ca","#fbedda","#fcf3e8","#fdf8f2","#fefcfa"],
        "typecolor": "#ff0000",
    }
}

export default VariantStyles
